import { render, staticRenderFns } from "./dispatchBoard.vue?vue&type=template&id=5c05129b&scoped=true&"
import script from "./dispatchBoard.vue?vue&type=script&lang=js&"
export * from "./dispatchBoard.vue?vue&type=script&lang=js&"
import style0 from "./dispatchBoard.vue?vue&type=style&index=0&id=5c05129b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c05129b",
  null
  
)

export default component.exports